export {
  OWNERSHIP_TYPES,
  TITLES as OWNER_TITLES,
  canonicalOwnershipType,
  canonicalOwnerTitle,
} from "@/features/applications/components/v2/constants";

export function isSoleProprietor(ownershipType: string): boolean {
  return ownershipType.trim().toLowerCase().startsWith("sole propriet");
}

export const ACCOUNT_TYPES = ["Checking", "Savings"];
